import axios, { AxiosError } from 'axios'
import config from 'config'
import AssetType from 'state/enums/AssetType'
import convertObjectToQueryString from 'utils/convertObjectToQueryString'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'

export interface GetTrimsOptions {
    condition: 'new' | 'used'
    year: number
    makeId: number
    modelId: number
    offset?: number
    limit?: number
    captive?: string
}

export interface Trim {
    automobile_id: number
    trim: string
    nada_id: string
    year: number
    condition: string
}

export default async function getTrims(
    options: GetTrimsOptions,
    abortController: AbortController,
): Promise<Trim[]> {
    const queryString = convertObjectToQueryString(
        {
            asset_type: AssetType.AUTOMOBILE,
            condition: options.condition,
            year: options.year,
            make_id: options.makeId,
            model_id: options.modelId,
            offset: options.offset ?? 0,
            limit: options.limit ?? 5000,
            captive: options.captive,
        },
        true,
    )

    const url = `${config.API_BASE_URL}/api/v3/vehicles/trims/?${queryString}`

    try {
        const { data } = await axios.get(url, {
            signal: abortController.signal,
            withCredentials: true,
        })

        return data.results.map((result: Trim) => ({
            automobile_id: result.automobile_id,
            trim: result.trim,
            nada_id: result.nada_id,
            year: result.year,
            condition: result.condition,
        }))
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get trims: ${axiosError.message}`,
            axiosError,
        )

        throw new Error(axiosError.message)
    }
}
